import { Button, Divider, Input, Modal, Select } from "antd";
import { useState } from "react";
import { toastError, toastSuccess } from "../../utils/toast";
import { apiUpdateMethodSelectProviderCurrent } from "../../api";
import { useLoading } from "../../context/LoadingContext";
import { systemMethodSelectProviderOptions } from "../../assets/constants/default_option";

export default function ModalMethodSelectProvider({ isOpen, setIsOpen, data, fetchData }: any) {
    const [methodValue, setMethodValue] = useState('')
    const [otpConfirm, setOtpConfirm] = useState('')

    const { setIsLoading } = useLoading()

    const handleUpdate = async () => {
        if (!methodValue) {
            toastError('Vui lòng chọn phương thức!')
            return
        }
        if (data === methodValue) {
            toastError('Vui lòng chọn phương thức khác!')
            return
        }
        if (!otpConfirm) {
            toastError('Vui lòng nhập mã OTP xác nhận!')
            return
        }

        try {
            setIsLoading(true)
            const resp = await apiUpdateMethodSelectProviderCurrent({
                value: methodValue,
                otpConfirm: otpConfirm,
            })
            if (resp.status === 200) {
                fetchData()
                setIsOpen(false)
                toastSuccess('Cập nhật thành công')
                setOtpConfirm('')
                setMethodValue('')
            }
        } catch (error) {
            toastError('Cập nhật thất bại')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const getMethodLabel = (value: string) => {
        switch (value) {
            case 'static':
                return 'Static'
            case 'weightrandom':
                return 'Weight Random'
            case 'loadbalance':
                return 'Load Balance'
            default:
                return 'Không có'
        }
    }

    return (
        <Modal
            title="Cập nhật phương thức chọn nhà cung cấp"
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            footer={[
                <Button onClick={handleUpdate} type="primary">
                    Cập nhật
                </Button>
            ]}
        >
            <p><span style={{ color: 'red' }}>*</span> Chọn phương thức</p>
            <Select
                style={{ width: '100%' }}
                placeholder="Chọn phương thức"
                value={methodValue}
                onChange={value => setMethodValue(value)}
                options={systemMethodSelectProviderOptions}
            />
            <p><span style={{ color: 'red' }}>*</span> Nhập mã OTP xác nhận</p>
            <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
            <Divider />
        </Modal>
    )
}

